import { getDataIdsFromContract } from '../../../shared/utils/dataId';

const JOB_DETAILS_DATA_IDS = {
  base: 'job-details',
  loader: 'loader',
  statsBox: 'stats-box',
  objectList: 'object-list',
  retryAlert: 'retry-alert'
};

export const jobDetailsDataIds = getDataIdsFromContract(JOB_DETAILS_DATA_IDS);

export const JOB_STATS_BOX_DATA_IDS = {
  base: 'job-details',
  refreshBtn: 'refresh',
  downloadLog: 'downloadLog',
  backBtn: 'back',
  cancelJobBtn: 'cancelJob',
  retryBtn: '',
  jobStats: 'job-stats',
  status: 'status',
  jobId: 'job-id',
  failureBanner: 'failure-banner'
};

const JOB_STATS_TABLE_DATA_IDS = {
  base: 'jobStatsContent',
  startedAt: 'startedAt',
  duration: 'duration',
  position: 'position',
  objectsSuccess: 'objectsSuccess',
  objectsQueued: 'objectsQueued',
  objectsFailed: 'objectsFailed',
  eventsIngested: 'eventsIngested',
  eventsLoaded: 'eventsLoaded',
  eventsFailed: 'eventsFailed',
  billableEvents: 'billableEvents',
  nonBillableEvents: 'nonBillableEvents',
  latency: 'latency'
};

export const jobStatsTableDataIds = getDataIdsFromContract(JOB_STATS_TABLE_DATA_IDS);
